
/*
 *
 * DisputeUci Actions
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 04-Feb-2026
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_SHOP_SELECTOR_DISPUTE_UCI_INFO: '@@DisputeUci/shop_selector_dispute_uci_info',
  DO_GET_DISPUTES_PENDING: '@@DisputeUci/get_disputes_pending',
  DO_GET_DISPUTES_IN_PROGRESS: '@@DisputeUci/get_disputes_in_progress',
  DO_GET_DISPUTES_CLOSED: '@@DisputeUci/get_disputes_closed',
  DO_DOWNLOAD_DISPUTE_LIST: '@@DisputeUci/download_dispute_list',
  DO_SET_DISPUTE_FILTERS: '@@DisputeUci/do_set_dispute_filters',
  DO_GET_DISPUTE_UCI_FILTERS: '@@DisputeUci/get_dispute_uci_filters',
  DO_GET_DOSSIER_HISTORY: '@@DisputeUci/get_dossier_history',
  DO_GET_DISPUTE_UCI_DETAILS: '@@DisputeUci/get_dispute_uci_details',
  DO_DOWNLOAD_DOCUMENT_PRACTICE: '@@DisputeUci/download_document_practice',
  DO_EVASION_PRACTICE: '@@DisputeUci/evasion_practice',
  DO_UPLOAD_DOCUMENT: '@@DisputeUci/upload_document',
  // @generator action:route:type
  ...createRequestTypes('@@DisputeUci', 'SHOP_SELECTOR_DISPUTE_UCI_INFO'),
  ...createRequestTypes('@@DisputeUci', 'GET_DISPUTE_UCI_DETAILS'),
  ...createRequestTypes('@@DisputeUci', 'GET_DISPUTE_UCI_FILTERS'),
  ...createRequestTypes('@@DisputeUci', 'GET_DISPUTES_PENDING'),
  ...createRequestTypes('@@DisputeUci', 'GET_DISPUTES_IN_PROGRESS'),
  ...createRequestTypes('@@DisputeUci', 'GET_DISPUTES_CLOSED'),
  ...createRequestTypes('@@DisputeUci', 'DOWNLOAD_DISPUTE_LIST'),
  ...createRequestTypes('@@DisputeUci', 'GET_DOSSIER_HISTORY'),
  ...createRequestTypes('@@DisputeUci', 'DOWNLOAD_DOCUMENT_PRACTICE'),
  ...createRequestTypes('@@DisputeUci', 'EVASION_PRACTICE'),
  ...createRequestTypes('@@DisputeUci', 'UPLOAD_DOCUMENT')
// @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
* * Insert a description
* @name uploadDocument
* @return {object} - The action object
*/
export const uploadDocument = new MakeRequest('DisputeUci', 'upload_document')
/** @action request
* * Insert a description
* @name evasionPractice
* @return {object} - The action object
*/
export const evasionPractice = new MakeRequest('DisputeUci', 'evasion_practice')
/** @action request
* * Insert a description
* @name downloadDocumentPractice
* @return {object} - The action object
*/
export const downloadDocumentPractice = new MakeRequest('DisputeUci', 'download_document_practice')
/** @action request
 * @name getDisputeUciFilters
 */
export const getDisputeUciFilters = new MakeRequest('DisputeUci', 'get_dispute_uci_filters')

/** @action request
 * @name getDisputeUciDetails
 */
export const getDisputeUciDetails = new MakeRequest('DisputeUci', 'get_dispute_uci_details')

/** @action request
* * Insert a description
* @name getDossierHistory
* @return {object} - The action object
*/
export const getDossierHistory = new MakeRequest('DisputeUci', 'get_dossier_history')

/** @action request
 * @name shopSelectorDisputeUciInfo
 * @return {object} - The action object
 */
export const shopSelectorDisputeUciInfo = new MakeRequest('DisputeUci', 'shop_selector_dispute_uci_info')

/** @action request
 * @name getDisputesPending
 */
export const getDisputesPending = new MakeRequest('DisputeUci', 'get_disputes_pending')

/** @action request
 * @name getDisputesInProgress
 */
export const getDisputesInProgress = new MakeRequest('DisputeUci', 'get_disputes_in_progress')

/** @action request
 * @name getDisputesClosed
 */
export const getDisputesClosed = new MakeRequest('DisputeUci', 'get_disputes_closed')

/** @action request
 * @name downloadDisputeList
 */
export const downloadDisputeList = new MakeRequest('DisputeUci', 'download_dispute_list')

// @generator action:route
/** @action
* * Insert a description
* @name EvasionPractice
* @return {object} - The payload object
*/
export const doEvasionPractice = payload => createAction(actionTypes.DO_EVASION_PRACTICE, { payload })
/** @action
* * Insert a description
* @name UploadDocument
* @return {object} - The payload object
*/
export const doUploadDocument = payload => createAction(actionTypes.DO_UPLOAD_DOCUMENT, { payload })
/** @action
* * Insert a description
* @name DownloadDocumentPractice
* @return {object} - The payload object
*/
export const doDownloadDocumentPractice = payload => createAction(actionTypes.DO_DOWNLOAD_DOCUMENT_PRACTICE, { payload })
/** @action
* * Insert a description
* @name GetDossierHistory
* @return {object} - The payload object
*/
export const doGetDossierHistory = payload => createAction(actionTypes.DO_GET_DOSSIER_HISTORY, { payload })

/** @action
 * @name doShopSelectorDisputeUciInfo
 */
export const doShopSelectorDisputeUciInfo = payload => createAction(actionTypes.DO_SHOP_SELECTOR_DISPUTE_UCI_INFO, { payload })

/** @action
 * @name doGetDisputesPending
 */
export const doGetDisputesPending = payload => createAction(actionTypes.DO_GET_DISPUTES_PENDING, { payload })

/** @action
 * @name doGetDisputesInProgress
 */
export const doGetDisputesInProgress = payload => createAction(actionTypes.DO_GET_DISPUTES_IN_PROGRESS, { payload })

/** @action
 * @name doGetDisputesClosed
 */
export const doGetDisputesClosed = payload => createAction(actionTypes.DO_GET_DISPUTES_CLOSED, { payload })

/** @action
 * @name doDownloadDisputeList
 */
export const doDownloadDisputeList = payload => createAction(actionTypes.DO_DOWNLOAD_DISPUTE_LIST, { payload })

/** @action
 * @name doSetDisputeFilters
 * @param {{ tab: 'PENDING'|'PROCESSING'|'CLOSED', filters: object }} payload
 */
export const doSetDisputeFilters = payload => createAction(actionTypes.DO_SET_DISPUTE_FILTERS, { payload })

/** @action
 * @name doGetDisputeUciFilters
 */
export const doGetDisputeUciFilters = payload => createAction(actionTypes.DO_GET_DISPUTE_UCI_FILTERS, { payload })

/** @action
 * @name doGetDisputeUciDetails
 */
export const doGetDisputeUciDetails = payload => createAction(actionTypes.DO_GET_DISPUTE_UCI_DETAILS, { payload })
